import { useState, useEffect } from 'react';
import PostFormStep1 from './PostFormStep1';
import PostFormStep2Canvas from './PostFormStep2Canvas';
import { createFootprint } from '../../services/footprintService';

// ── ステップバー ───────────────────────────────────────
const STEPS = ['フォト', 'お絵描き', '完了'];

const StepBar = ({ step, onClose, showCloseButton = true, isCollapsed = false, onToggleCollapse }) => (
  <div className="sticky top-0 z-10 border-b border-gray-200 bg-white">
    {/* 折りたたむ／広げる ボタン行 */}
    {onToggleCollapse && (
      <div className="flex justify-center border-b border-gray-100 bg-gray-50 py-1">
        <button
          onClick={onToggleCollapse}
          className="rounded-full bg-gray-200 px-4 py-0.5 text-xs font-bold text-gray-600 hover:bg-gray-300 transition-colors"
          aria-label={isCollapsed ? '広げる' : '折りたたむ'}
        >
          {isCollapsed ? '広げる' : '折りたたむ'}
        </button>
      </div>
    )}

    {/* タイトル行 */}
    <div className="flex items-center justify-between px-4 py-3">
      <div className="flex-1" />
      <p className="text-center text-lg font-bold text-gray-800">足あとフォト</p>
      <div className="flex flex-1 justify-end">
        {showCloseButton && (
          <button
            onClick={onClose}
            className="rounded-full bg-gray-200 px-3 py-0.5 text-xs font-bold text-gray-600 hover:bg-gray-300 transition-colors"
          >
            閉じる
          </button>
        )}
      </div>
    </div>
    
    {/* ステップバー */}
    <div className="flex items-center justify-center gap-1 border-t border-gray-100 px-4 py-3">
      {STEPS.map((label, i) => {
        const n = i + 1;
        const done = step > n;
        const active = step === n;
        return (
          <div key={n} className="flex items-center">
            {/* サークル */}
            <div className="flex flex-col items-center gap-0.5">
              <div
                className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold transition-colors
                  ${done ? 'bg-amber-400 text-white' : active ? 'bg-amber-500 text-white' : 'bg-gray-200 text-gray-400'}`}
              >
                {done ? '✓' : n}
              </div>
              <span className={`text-[10px] ${active ? 'font-bold text-amber-600' : 'text-gray-400'}`}>
                {label}
              </span>
            </div>
            {/* コネクター */}
            {i < STEPS.length - 1 && (
              <div className={`mb-4 h-0.5 w-8 ${done ? 'bg-amber-400' : 'bg-gray-200'}`} />
            )}
          </div>
        );
      })}
    </div>
  </div>
);

// ── 足あとSVGアイコン ────────────────────────────────────
const FootprintIcon = () => (
  <svg viewBox="0 0 62.84 64.9" style={{ width: '100%', height: '100%' }}>
    <g>
      <path fill="#D97706" d="M61.54,9.44c-.33-.05-.73-.01-1.16.12l-12.78,3.75c-1.72.51-2.06,1.95-.76,3.19l1.41,1.34c1.95.78,3.72,2.2,4.69,3.88l.77,1.32,2.76,2.62c.43.41.87.64,1.28.7.85.13,1.58-.45,1.87-1.62l3.12-12.93c.3-1.32-.21-2.22-1.21-2.37Z"/>
      <path fill="#D97706" d="M49.25,23.89c-.67-1.15-2.23-2.15-3.61-2.36-.13-.02-.27-.03-.4-.04l-23.53-.74c-.33,0-.67.04-1,.13-.31.71-.77,1.4-1.36,2.01l-2.45,2.59-9.42,21.03c-.61,1.34-.22,3.25.86,4.24l13.31,12.32c.9.83,2.51,1.54,3.88,1.75.26.04.51.06.75.06h19.71c1.47,0,3.18-1.07,3.84-2.4l8.86-18.16c.65-1.31.57-3.44-.18-4.7l-9.25-15.74Z"/>
      <path fill="#D97706" d="M24.15,15.66c.18.03.36.04.57.03l13.31-.34c1.79-.04,2.5-1.34,1.56-2.87l-6.94-11.35c-.41-.67-.92-1.04-1.44-1.12-.67-.1-1.35.3-1.84,1.19l-6.37,11.69c-.77,1.4-.24,2.55,1.15,2.76Z"/>
      <path fill="#D97706" d="M15.32,16.8l-12.94-3.12c-.1-.02-.2-.04-.29-.05-1.57-.24-2.44.8-1.97,2.43l3.76,12.77c.27.92.8,1.44,1.43,1.54.55.09,1.17-.16,1.75-.77l9.17-9.64c1.24-1.3.82-2.72-.92-3.15Z"/>
    </g>
  </svg>
);

// ── 閉じる確認モーダル ─────────────────────────────────
const CloseConfirmDialog = ({ onConfirm, onCancel }) => (
  <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-6">
    <div className="w-full max-w-xs rounded-2xl bg-white p-6 shadow-xl">
      <p className="mb-1 text-center text-base font-bold text-gray-800">投稿をやめますか？</p>
      <p className="mb-5 text-center text-xs text-gray-500">入力した内容はすべて削除されます</p>
      <div className="flex gap-3">
        <button
          onClick={onCancel}
          className="flex-1 rounded-full border border-gray-300 py-2 text-sm text-gray-600"
        >
          キャンセル
        </button>
        <button
          onClick={onConfirm}
          className="flex-1 rounded-full bg-red-500 py-2 text-sm font-bold text-white"
        >
          削除する
        </button>
      </div>
    </div>
  </div>
);

// ── STEP3 完了画面 ────────────────────────────────────
const CompletionScreen = ({ onClose, onCloseRequest }) => (
  <div className="fixed inset-x-0 bottom-0 z-50 mx-auto w-full max-w-lp rounded-t-2xl bg-white shadow-xl">
    <StepBar step={3} onClose={onCloseRequest} showCloseButton={false} />
    <div className="flex flex-col items-center gap-4 px-6 py-8">
      <div className="flex h-20 w-20 items-center justify-center rounded-full">
        <FootprintIcon />
      </div>
      <p className="text-xl font-bold text-gray-800">足あとを置きました！</p>
      <p className="text-center text-sm text-gray-500">
        あなたの足あとがマップに追加されました。<br />みんなに見てもらえるよ！
      </p>
      <button
        onClick={onClose}
        className="mt-2 w-full rounded-full bg-amber-500 py-3 font-bold text-white"
      >
        マップに戻る
      </button>
    </div>
  </div>
);

/**
 * 足あと投稿フォーム（3ステップ）
 *
 * STEP 1: 写真・ニックネーム・すっごーい！足あと選択
 * STEP 2: 手書きコメント（Canvasキャンバス）
 * STEP 3: 投稿完了
 */
const PostFormModal = ({ location, onClose, onSuccess, onIsSuperChange }) => {
  const [step, setStep] = useState(1);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [step1Data, setStep1Data] = useState(null); // { photoFile, nickname, isSuper }
  const [savedCanvasDataUrl, setSavedCanvasDataUrl] = useState(null); // キャンバス内容を保持
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);

  // step1Data の isSuper が変更されたら親に通知
  useEffect(() => {
    if (step1Data && onIsSuperChange) {
      onIsSuperChange(step1Data.isSuper);
    }
  }, [step1Data?.isSuper, onIsSuperChange]);

  const handleStep1Next = (data) => {
    setStep1Data(data);
    setStep(2);
  };

  const handleStep2Submit = async (handwritingDataUrl) => {
    setSubmitting(true);
    setError(null);
    try {
      const result = await createFootprint({
        photoFile: step1Data.photoFile,
        handwritingDataUrl,
        nickname: step1Data.nickname,
        isSuper: step1Data.isSuper,
        location,
        address: step1Data.address ?? null,
      });
      if (result.success) {
        setStep(3);
      } else {
        setError(result.message ?? '投稿に失敗しました');
      }
    } catch {
      setError('通信エラーが発生しました');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseRequest = () => setShowCloseConfirm(true);

  return (
    <>
      {showCloseConfirm && (
        <CloseConfirmDialog
          onConfirm={onClose}
          onCancel={() => setShowCloseConfirm(false)}
        />
      )}

      {step === 1 && (
        <PostFormStep1
          location={location}
          initialData={step1Data}
          onNext={handleStep1Next}
          onClose={handleCloseRequest}
          stepBar={
            <StepBar 
              step={1} 
              onClose={handleCloseRequest} 
              isCollapsed={isCollapsed}
              onToggleCollapse={() => 
                setIsCollapsed((v) => !v)
              }
            />
          }
          isCollapsed={isCollapsed}
          onIsSuperChange={onIsSuperChange}
        />
      )}
      {step === 2 && (
        <PostFormStep2Canvas
          onSubmit={handleStep2Submit}
          onBack={(dataUrl) => {
            if (dataUrl) setSavedCanvasDataUrl(dataUrl); // 戻る時にキャンバス内容を保存
            setStep(1);
          }}
          onClose={handleCloseRequest}
          submitting={submitting}
          error={error}
          initialDataUrl={savedCanvasDataUrl} // 保存済み内容を復元
          stepBar={
            <StepBar
              step={2}
              onClose={handleCloseRequest}
              isCollapsed={isCollapsed}
              onToggleCollapse={() => setIsCollapsed((v) => !v)}
            />
          }
          isCollapsed={isCollapsed}
        />
      )}
      {step === 3 && (
        <CompletionScreen onClose={() => { onSuccess(); onClose(); }} onCloseRequest={handleCloseRequest} />
      )}
    </>
  );
};

export default PostFormModal;
